import Vue from 'vue'
import router from './../router'
import config from './../config'

export default {
  user: {
    authenticated: false
  },
  async login (context, creds, redirect) {
    const form = new FormData()
    form.append('username', creds.username)
    form.append('password', creds.password)
    try {
      const response = await fetch(
        config.services.users.url + '/login', {
          method: 'POST',
          mode: 'cors',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          },
          body: form
        }
      )
      if (response.status === 400 || response.status === 401) {
        context.error = 'Nieprawidłowe dane logowania'
        return
      }
      await this.handleErrors(response)
      const userData = await response.json()
      localStorage.setItem('id_token', userData.id_token)
      // localStorage.setItem('access_token', data.access_token)
      this.user.authenticated = true
      if (redirect) {
        context.$router.go() // Reload page to load proper components dependent on user type
        await context.$router.push(redirect)
      }
    } catch (e) {
      console.log(e)
    }
  },
  logout () {
    localStorage.removeItem('id_token')
    localStorage.removeItem('access_token')
    this.user.authenticated = false
    router.push({ name: 'login' }).catch({})
  },
  checkAuth () {
    const jwt = localStorage.getItem('id_token')
    this.user.authenticated = (jwt !== 'undefined' && jwt !== null)
  },
  async authorizedFetch (url, options, method) {
    const newOptions = (typeof options === 'undefined') ? {} : options
    newOptions.method = (typeof method === 'undefined') ? 'GET' : method
    newOptions.mode = 'cors'
    newOptions.credentials = 'same-origin'
    newOptions.headers = {}
    newOptions.headers.Authorization = 'Bearer ' + localStorage.getItem('id_token')
    newOptions.headers.Accept = 'application/json'

    const response = await fetch(url, newOptions)
    await this.handleErrors(response)
    if (response.status === 401) {
      this.user.authenticated = false
      this.logout()
      return response
    }
    const responseBody = await response.text()
    return this.isJsonString(responseBody) ? JSON.parse(responseBody) : {}
  },
  async handleErrors (response) {
    if (!response.ok && response.status !== 401) {
      try {
        const data = await response.clone().json()
        if ('errors' in data) {
          Vue.notify({ group: 'notify', type: 'error', title: data.errors, text: '' })
        } else {
          throw Error()
        }
      } catch (e) {
        Vue.notify({ group: 'notify', type: 'error', title: 'Blad', text: '' })
      }
      console.error(response)
      throw Error()
    }
  },
  isJsonString (str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },
  computed: {
    userData: () => {
      const base64Url = localStorage.getItem('id_token').split('.')[1]
      const base64 = base64Url.replace('-', '+').replace('_', '/')
      return JSON.parse(window.atob(base64))
    }
  }
}
